import clsx from 'clsx';
import React, { ReactNode, useEffect, useRef, useState } from 'react';
import SidebarCrossIcon from '../../assets/icons/sidebar-cross-icon.svg?react';

interface AccordionProps {
  otherClasses?: string;
  title: string;
  description: string | ReactNode;
}

const Accordion: React.FC<AccordionProps> = ({
  otherClasses,
  title,
  description,
}) => {
  const accordionClasses = clsx(
    otherClasses,
    ' py-2 lg:py-5 px-15 lg:px-6 bg-card-backgrounds/5 border-neutral-tones-text/10 border rounded-lg lg:rounded-xl flex items-center gap-0 lg:gap-2',
  );

  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLParagraphElement>(null);
  const [height, setHeight] = useState(0);
  const [shouldAnimate, setShouldAnimate] = useState(false);

  useEffect(() => {
    if (ref.current) {
      const contentHeight = ref?.current?.scrollHeight;
      if (isOpen) {
        setShouldAnimate(true);
        setHeight(contentHeight);
      } else {
        setHeight(0);
      }
    }
  }, [isOpen, description]);

  return (
    <div className={accordionClasses} data-testid="accordion">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-9 min-w-9 cursor-pointer"
      >
        <SidebarCrossIcon
          className={clsx(
            'global-transition',
            isOpen ? 'h-7 w-7 rotate-0' : 'h-5 w-5 rotate-45 lg:h-6 lg:w-6',
          )}
        />
      </button>
      <div>
        <button
          className="text-neutral-tones-text font-inter-variable flex cursor-pointer items-center text-left text-sm font-bold lg:text-xl"
          onClick={() => setIsOpen(!isOpen)}
        >
          {title}
        </button>
        <p
          ref={ref}
          className={clsx(
            'text-inter-variable global-transition text-neutral-tones-text text-sm leading-5 font-normal lg:text-lg lg:leading-6',
            isOpen ? 'mt-15 overflow-auto' : 'overflow-hidden',
          )}
          style={{
            height: shouldAnimate ? `${height}px` : isOpen ? '0px' : '0px',
          }}
        >
          {description}
        </p>
      </div>
    </div>
  );
};

export default Accordion;
